export { default as Header } from './modules/Header';
export { default as Load } from './modules/Load';
export { default as Menu } from './modules/Menu';
export { default as Sliders } from './modules/Sliders';
export { default as Scroll } from './modules/Scroll';
export { default as Page } from './modules/Page';
export { default as Bold } from './modules/Bold';
export { default as Carousel } from './modules/Carousel';
export { default as CarouselArticle } from './modules/CarouselArticle';
export { default as Images } from './modules/Images';
export { default as Player } from './modules/Player';
export { default as Number } from './modules/Number';
export { default as Newsletter } from './modules/Newsletter';
